export let PaneMode = /*#__PURE__*/function (PaneMode) {
  PaneMode["videoAndContent"] = "videoAndContent";
  PaneMode["slider"] = "slider";
  PaneMode["trainer"] = "trainer";
  return PaneMode;
}({});